import React, { useState, useEffect } from 'react'
import Lightbox from 'react-images'
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom'
import CloseIcon from '@material-ui/icons/Close'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { IconButton } from '@material-ui/core'
import * as R from 'ramda'
import effects from 'app/effects/effects'
import apiConfig from 'app/configs/apiConfigs'

const PATH_LENGTH = 4

const useStyles = makeStyles({
  menuButton: {
    paddingLeft: '1.25rem',
    paddingRight: '1.25rem',
    paddingTop: '0.5rem',
    display: 'inline-block',
    cursor: 'pointer',
  },
})

const TimelineLightbox = (props) => {
  const {
    isOpen,
    images = [],
    onClose,
    showCloseButton = false,
    showImageCount = false,
    showThumbnails = true,
  } = props

  const lbClasses = useStyles()

  const [currentImage, setCurrentImage] = useState(0)
  const [imageCount, setImageCount] = useState('')

  useEffect(() => {
    setImageCount(`${currentImage + 1}/${images.length}`)
  }, [currentImage, images])

  const goToImage = (index) => {
    setCurrentImage(index)
  }

  const onClickNext = () => {
    setCurrentImage(currentImage + 1)
  }

  const onClickPrev = () => {
    setCurrentImage(currentImage - 1)
  }

  const onClickDownload = () => {
    const url = R.path([currentImage, 'src'], images)
    const downloadableLink = R.compose(
      getDownloadableLink,
      getImageObjPathFromUrl,
    )(url)
    const filename = R.compose(R.last, R.split('/'))(url)

    if (url) {
      effects.apis
        .downloadImageFromUrl({
          url: downloadableLink,
        })
        .then(({ data }) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]))
          const link = document.createElement('a')
          link.href = downloadUrl
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
        .catch((e) => {
          console.log('error', e)
        })
    } else {
      console.log('could not download file for url: ', url)
    }
  }

  const getDownloadableLink = (path) => {
    return `${apiConfig.awsBucketUrl}/${path}`
  }

  const getImageObjPathFromUrl = R.compose(
    R.join('/'),
    R.takeLast(PATH_LENGTH),
    R.split('/'),
  )

  const onClickClose = () => {
    setCurrentImage(0)
    onClose()
  }

  return (
    <>
      <Lightbox
        images={images}
        currentImage={currentImage}
        backdropClosesModal={true}
        isOpen={isOpen}
        showCloseButton={showCloseButton}
        showImageCount={showImageCount}
        onClose={onClickClose}
        showThumbnails={showThumbnails}
        onClickNext={onClickNext}
        onClickPrev={onClickPrev}
        onClickThumbnail={goToImage}
        // to do Missing "key" prop for element in array
        customControls={[
          <div className="w-full">
            <IconButton
              key="closeLightBox"
              className={lbClasses.menuButton}
              onClick={onClickClose}
            >
              <CloseIcon fontSize="large" style={{ color: 'white' }} />
            </IconButton>
            <IconButton
              key="deleteImage"
              className={lbClasses.menuButton}
              onClick={onClickDownload}
            >
              <VerticalAlignBottomIcon
                fontSize="large"
                style={{ color: 'white' }}
              />
            </IconButton>
            <p className="absolute right-0 text-lg text-white inline pt-2">
              {imageCount}
            </p>
          </div>,
        ]}
      />
    </>
  )
}

TimelineLightbox.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      thumbnail: PropTypes.string.isRequired,
      caption: PropTypes.string,
    }),
  ),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
}

export default TimelineLightbox

export const mediaToImages = (medias) => {
  return medias
    ? medias.map((media) => {
        return {
          src: media.url,
          thumbnail: media.url,
          caption: '',
        }
      })
    : []
}
